module.exports = __webpack_public_path__ + "images/insta-service-menu53bb2a24af582d53fdff880aec86c30b.svg";